import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { isScrollingDisabled } from '../../ducks/ui.duck';
import { CANTONS, regionPath, regionSlug } from '../../util/regions';
import { hubPageSchema } from '../../util/landingSchema';

import LandingLayout from './LandingLayout';
import Hero from './sections/Hero';
import ClaimBanner from './sections/ClaimBanner';
import CardGrid from './sections/CardGrid';
import FinalCta from './sections/FinalCta';

const DESCRIPTION =
  'Hochzeitsdienstleister nach Kanton: Location, Catering, Fotograf:in, Musik und mehr – in allen 26 Kantonen der Schweiz.';

export const RegionHubPageComponent = props => {
  const { scrollingDisabled } = props;

  return (
    <LandingLayout
      title="Hochzeitsdienstleister nach Region – alle 26 Kantone | Toastably"
      description={DESCRIPTION}
      schema={hubPageSchema(
        'Regionen',
        '/region/',
        CANTONS.map(c => ({ name: c.label, path: regionPath(c.option) }))
      )}
      currentPage="RegionHubPage"
      scrollingDisabled={scrollingDisabled}
    >
      <Hero
        crumbs={[{ label: 'Startseite', link: { name: 'LandingPage' } }, { label: 'Regionen' }]}
        heading="Hochzeitsdienstleister nach Region"
        lead={DESCRIPTION}
        primaryCta={{ link: { name: 'SearchPage' }, label: 'Jetzt Angebote entdecken' }}
      />

      <CardGrid
        id="regions-title"
        heading="Alle Kantone"
        text="Wählt euren Kanton und seht, wer dort arbeitet."
        items={CANTONS.map(c => ({
          key: c.option,
          link: { name: 'RegionLandingPage', params: { slug: regionSlug(c.option) } },
          label: c.label,
        }))}
      />

      <ClaimBanner />

      <FinalCta
        heading="Findet eure Hochzeitsdienstleister:innen"
        text="Vergleicht Angebote aus der ganzen Schweiz und bucht direkt über die Plattform."
        link={{ name: 'SearchPage' }}
        label="Jetzt Angebote entdecken"
      />
    </LandingLayout>
  );
};

const mapStateToProps = state => ({ scrollingDisabled: isScrollingDisabled(state) });

export default compose(connect(mapStateToProps))(RegionHubPageComponent);
